import React, { useState } from "react";
import { FormLabel } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import PreferenceTag, { TagType } from "@/components/common/PreferenceTag";

export interface Tag {
  id: string;
  label: string;
  type: TagType;
}

interface TagsSectionProps {
  tags: Tag[];
  onAddTag: (label: string, type: TagType) => void;
  onRemoveTag: (id: string) => void;
}

export const TagsSection: React.FC<TagsSectionProps> = ({
  tags,
  onAddTag,
  onRemoveTag
}) => {
  const [newTag, setNewTag] = useState("");
  const [newTagType, setNewTagType] = useState<TagType>("interest");

  const handleAddTag = () => {
    if (newTag.trim()) {
      onAddTag(newTag.trim(), newTagType);
      setNewTag("");
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTag();
    }
  };

  return (
    <div className="space-y-4">
      <FormLabel>Preferences & Interests</FormLabel>
      
      <div className="flex flex-wrap gap-2">
        {tags.map((tag) => (
          <PreferenceTag
            key={tag.id}
            label={tag.label}
            type={tag.type}
            removable
            onRemove={() => onRemoveTag(tag.id)}
          >
            {tag.label}
          </PreferenceTag>
        ))}
      </div>

      <div className="flex gap-2">
        <Select
          value={newTagType}
          onValueChange={(value) => setNewTagType(value as TagType)}
        >
          <SelectTrigger className="w-[140px]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="interest">Interest</SelectItem>
            <SelectItem value="preference">Preference</SelectItem>
            <SelectItem value="remember">Remember</SelectItem>
            <SelectItem value="avoid">Avoid</SelectItem>
          </SelectContent>
        </Select>
        
        <Input
          value={newTag}
          onChange={(e) => setNewTag(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Add a tag (e.g., likes hiking)"
          className="flex-1"
        />
        
        <Button
          type="button"
          onClick={handleAddTag}
          disabled={!newTag.trim()}
        >
          Add
        </Button>
      </div>
    </div>
  );
};